export class LicenseCustomer implements ILicenseCustomer {
    constructor(licenseCustomer?: ILicenseCustomer) {
        if (licenseCustomer) {
            this.billingGroupId = licenseCustomer.billingGroupId;
            this.customerId = licenseCustomer.customerId;
            this.userEmail = licenseCustomer.userEmail;
            this.userFirstName = licenseCustomer.userFirstName;
            this.userLastName = licenseCustomer.userLastName;
        }
    }

    billingGroupId: string;
    customerId: string;
    userEmail: string;
    userFirstName: string;
    userLastName: string;
}

export interface ILicenseCustomer {
    billingGroupId: string;
    customerId: string;
    userEmail: string;
    userFirstName: string;
    userLastName: string;
}